import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = t.marquee;
  const row = [...items, ...items, ...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="relative py-10 md:py-14 border-y border-white/5 bg-[#0c0c10] overflow-hidden"
    >
      <div className="ps-marquee-track">
        {row.map((label, i) => (
          <div key={i} className="flex items-center shrink-0 px-10">
            <span className="font-serif-display italic text-3xl md:text-5xl lg:text-6xl text-zinc-200 whitespace-nowrap">
              {label}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[var(--ps-gold)] mx-10 shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
